// config.js

const config = {
  // baseUrl: "http://localhost:8088", // 开发环境
  baseUrl: '/prs-api', // 正式环境
};

export default config;
